/*
 * Hi Markt — "Comeback" returning-visitor offer (client-side, presentation only).
 *
 * Shows a truthful, time-limited 15% offer to a visitor who returns to the SAME
 * product. Rules agreed with the operator:
 *   - Never on the 1st view. Appears from the 2nd qualifying view onward
 *     (same day or later). Two views count as separate only when >30 min apart
 *     (guards against a plain page refresh).
 *   - When first shown, a real 3-day window opens (stored as an absolute end
 *     timestamp). The countdown is truthful and is NEVER reset on later visits.
 *   - After the window ends the offer is over; it may reappear only after a
 *     14-day cooldown (a genuinely new period, not a fake reset). No cap.
 *   - Everything is stored in the visitor's own browser (localStorage). Nothing
 *     is sent to any server; no personal data is collected.
 *   - The box floats (fixed, bottom) and can be dismissed for the session.
 *     Its button is the store's own promo toggle (see snippets/hm-promo-row.liquid):
 *     applying and removing ZURUECK15 and switching the on-page price to the 15%
 *     value via `data-hm-promo-preis="promo2"`.
 *
 * Legal note: the countdown reflects a real end time (Omnibus/UWG — no fake
 * urgency). The banner shows no struck-through reference price.
 */
(function () {
  "use strict";
  var el = document.getElementById("hm-comeback");
  if (!el) return;
  // Section rendering can deliver this script twice; only the first run may bind.
  if (window.__hmComebackBound) return;
  window.__hmComebackBound = true;

  var handle = el.getAttribute("data-handle") || "";
  if (!handle) return;

  var GAP_MS = (parseInt(el.getAttribute("data-gap-min"), 10) || 30) * 60 * 1000;
  var WINDOW_MS = (parseInt(el.getAttribute("data-window-days"), 10) || 3) * 86400000;
  var COOLDOWN_MS = (parseInt(el.getAttribute("data-cooldown-days"), 10) || 14) * 86400000;
  var KEY = "hm_cb_" + handle;
  // Das X beendet NICHT das Angebot, es beendet nur das Schweben: der Kasten zieht unter
  // den Preis, dorthin wo sonst die Willkommenszeile steht, und bleibt dort fuer den Rest
  // des Angebotsfensters (Betreiber 2026-09-20).
  //
  // Dieser Zustand liegt im localStorage-Satz des Produkts, weil er das Schliessen des
  // Browsers ueberdauern soll — das Fenster laeuft drei Tage, eine Sitzung selten.
  //
  // KORREKTUR 2026-09-20: hier stand, sessionStorage sei in diesem Shop unbrauchbar, weil
  // Kalles' global.min.js `sessionStorage.clear()` ruft. Der Aufruf ist auf
  // `"development"==Shopify.theme.role` beschraenkt, trifft also NUR die lokale
  // `theme dev`-Vorschau, nie den Laden. Die urspruengliche Messung stammte aus genau
  // dieser Vorschau und wurde falsch verallgemeinert.

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || "{}") || {}; }
    catch (e) { return {}; }
  }
  function save(s) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) { /* private mode */ }
  }

  // Operator preview: append ?hm_cb_preview=1 to force the banner on any visit.
  // Harmless in production — a real customer never carries this parameter.
  var forcePreview = /[?&]hm_cb_preview=1/.test(location.search);

  var now = Date.now();
  var st = load();
  if (!Array.isArray(st.views)) st.views = [];

  // Record this view only if it is meaningfully separate from the last one.
  var last = st.views.length ? st.views[st.views.length - 1] : 0;
  if (now - last > GAP_MS) st.views.push(now);
  // keep the array small
  if (st.views.length > 20) st.views = st.views.slice(-20);

  var qualifyingViews = st.views.length;
  var show = false;
  var fensterOffen = false; // a window is already running → keep the SAME countdown

  // The 3-day window opens when the offer is really SHOWN, not when the visitor merely
  // qualifies. With the delayed reveal below, opening it here would burn hours — or a
  // whole day — off a countdown the visitor never saw.
  if (st.cycleEnd && now < st.cycleEnd) {
    show = true;
    fensterOffen = true;
  } else if (st.cycleEnd && now >= st.cycleEnd) {
    // window finished; may restart only after the cooldown, on a real return
    var cooldownEnd = st.cycleEnd + COOLDOWN_MS;
    if (now >= cooldownEnd && qualifyingViews >= 2) show = true;
  } else {
    // never shown yet → eligible from the 2nd qualifying view
    if (qualifyingViews >= 2) show = true;
  }

  if (forcePreview) show = true;

  save(st);

  // Hat er den Kasten in DIESEM Fenster schon weggeklickt, erscheint er gleich als Zeile
  // unter dem Preis — ohne Wartezeit, denn eine ruhige Zeile draengt sich nicht auf.
  // Nur wenn im AKTUELLEN Fenster weggeklickt wurde. Sonst erschien der Kasten nach der
  // 14-Tage-Sperre sofort und als Zeile: `inlineAb` stammte noch aus dem alten Fenster,
  // und es wird erst in `fensterOeffnen()` geloescht — also zu spaet fuer diese Pruefung.
  var inlineModus = !forcePreview && !!st.inlineAb && !!st.cycleStart && st.inlineAb >= st.cycleStart;

  // Der Warenkorb-Horcher wird VOR dem Ausstieg montiert. Vorher stand er dahinter:
  // beim ERSTEN Besuch (noch nicht qualifiziert) stieg das Skript vorher aus, das
  // Hinzufuegen blieb unbemerkt, und die Rueckkehr nach 30 min in DERSELBEN Sitzung
  // zeigte das Angebot, obwohl der Artikel laengst im Korb lag.
  var GEKAUFT = "hm_cb_gekauft";
  var AKEY = "hm_cb_add_" + handle;
  // Geschrieben vom Custom Pixel "Comeback Kaufgedaechtnis" (checkout_completed):
  // je gekauftem Artikel der Handle UND "id:<Produktnummer>" — die Nummer faengt die
  // Faelle, in denen Shopify dem Pixel keine Produkt-URL mitgibt.
  var PRODUKT_ID = "id:" + (el.getAttribute("data-product-id") || "-");
  function gekauft() {
    try {
      var liste = JSON.parse(localStorage.getItem(GEKAUFT) || "[]") || [];
      return liste.indexOf(handle) >= 0 || liste.indexOf(PRODUKT_ID) >= 0;
    }
    catch (e) { return false; }
  }
  function schonGelegt() {
    try { return sessionStorage.getItem(AKEY) === "1"; } catch (e) { return false; }
  }
  var abgebrochen = false;

  // SECHS Stellen in diesem Theme rufen /cart/add.js (Produktseite, Warenkorbseite,
  // Merkliste, Karten-Runtime, Schnellansicht). Statt alle sechs anzufassen, wird
  // `fetch` hier EINMAL umhuellt — wer auch immer etwas hinzufuegt, wir erfahren es.
  // Geprueft wird die ANTWORT: nur wenn wirklich DIESES Produkt gelegt wurde, denn auf
  // der Seite liegen auch Karten anderer Artikel.
  (function () {
    var orig = window.fetch;
    if (typeof orig !== "function") return;
    window.fetch = function (eingabe) {
      var url = typeof eingabe === "string" ? eingabe : (eingabe && eingabe.url) || "";
      var antwort = orig.apply(this, arguments);
      if (url.indexOf("/cart/add") >= 0) {
        antwort.then(function (res) {
          try {
            res.clone().json().then(function (d) {
              var posten = (d && d.items) || (d ? [d] : []);
              var meins = posten.some(function (it) { return it && it.handle === handle; });
              if (!meins) return;
              try { sessionStorage.setItem(AKEY, "1"); } catch (e) {}
              abgebrochen = true;
              el.setAttribute("hidden", "");
              // Die Willkommenszeile wieder freigeben. Ohne das blieb die Seite nach dem
              // Hinzufuegen voellig OHNE Angebot zurueck: unser Kasten weg, und die 10-%-Zeile
              // hatte `uebernehmen()` schon ausgeblendet. Der Kunde sah also weniger als ein
              // Besucher, der nie zurueckgekommen waere.
              ["[data-hm-pd-promowrap]", ".hm-pd__sticky-promo"].forEach(function (sel) {
                document.querySelectorAll(sel).forEach(function (n) { n.style.display = ""; });
              });
            })["catch"](function () {});
          } catch (e) {}
        })["catch"](function () {});
      }
      return antwort;
    };
  })();

  if (!show) return;

  // ---- Zielregeln (Betreiber 2026-09-20) --------------------------------------
  //   gekauft von DIESEM Browser          -> nie zeigen
  //   in DIESER Sitzung in den Korb gelegt -> nicht zeigen (er ist schon ueberzeugt;
  //                                           der Rabatt kaufte nichts, er verschenkte)
  //   seit einem FRUEHEREN Besuch im Korb  -> zeigen (echtes Zoegern, Kaufabbruch)
  //   sonst                                -> zeigen, aber verzoegert (siehe unten)
  // Die Sitzungsmarke allein trennt Fall 2 von Fall 3: sessionStorage stirbt mit dem
  // Fenster, der Warenkorb lebt weiter. Ein /cart.js-Abruf ist dafuer nicht noetig.
  // Hat er den 10-%-Willkommensrabatt bereits AKTIVIERT, ist er ueberzeugt genug, um zu
  // klicken — dann kostet ein 15-%-Angebot nur die zusaetzlichen 5 % und bringt keine
  // Bestellung, die es sonst nicht gaebe. Dieselbe Logik wie beim gefuellten Warenkorb.
  // Nebeneffekt, der ebenso zaehlt: ohne diese Regel stuende der Willkommensknopf auf
  // "an" (Preis 423,00), waehrend der Kasten daneben "15 % aktivieren" anbietet — zwei
  // Rabatte gleichzeitig im Bild, von denen die Kasse nur einen kennt.
  function willkommenAktiv() {
    var b = document.querySelector("[data-hm-promo].is--on");
    return !!(b && !el.contains(b));
  }
  if (!forcePreview && (gekauft() || schonGelegt())) return;

  // Liegt im Warenkorb bereits ein gueltiger Rabattcode? Der Warenkorb ist die Wahrheit,
  // nicht die Knopfklasse: die haengt an der Sitzungsmarke und stirbt mit dem Fenster,
  // waehrend der Warenkorb wochenlang lebt. Ohne diese Pruefung bekam ein Kunde, der
  // gestern WILLKOMMEN10 eingeloest hat, heute in einer NEUEN Sitzung die 15 % obendrauf
  // — eine Aufwertung, um die er nie gebeten hat. Einmal geholt, nicht blockierend;
  // bis zur Anzeige (40 s) ist die Antwort laengst da. Bleibt sie aus, wird nicht
  // gesperrt: eine unbeantwortete Frage ist kein Grund, das Angebot zu verweigern.
  var korbRabatt = null;
  try {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        korbRabatt = !!(c && (c.discount_codes || []).some(function (d) { return d.applicable !== false; }));
      })["catch"](function () {});
  } catch (e) {}

  var timerEl = el.querySelector(".hm-cb__timer");
  var closeBtn = el.querySelector(".hm-cb__close");
  var end = st.cycleEnd || 0;

  function two(n) { return (n < 10 ? "0" : "") + n; }
  function fmt(ms) {
    if (ms <= 0) return "";
    var d = Math.floor(ms / 86400000);
    var h = Math.floor((ms % 86400000) / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    var clock = two(h) + ":" + two(m) + ":" + two(s);
    return d > 0
      ? "Endet in " + d + (d === 1 ? " Tag " : " Tagen ") + clock
      : "Endet in " + clock;
  }

  var uhr = null;
  function tick() {
    var rem = end - Date.now();
    // Der Kasten folgt der Verfuegbarkeit der gewaehlten Variante. Der Abschnitt setzt
    // dafuer `hidden` auf die Willkommenszeile (`prw.hidden = !v.available`); das wird
    // gespiegelt, statt die Variantenlogik ein zweites Mal zu bauen. Vorher bot der
    // Kasten 15 % auf eine Farbe, die gar nicht bestellbar ist.
    var wrap = document.querySelector("[data-hm-pd-promowrap]");
    if (wrap) el.classList.toggle("hm-cb--aus", wrap.hasAttribute("hidden"));

    if (rem > 0) {
      if (timerEl) timerEl.textContent = fmt(rem);
      return;
    }
    if (uhr) { clearInterval(uhr); uhr = null; }

    // Frist abgelaufen. Wurde der Rabatt NICHT eingeloest, ist das Angebot schlicht vorbei.
    var aktiv = el.querySelector("[data-hm-promo].is--on");
    if (!aktiv) { el.setAttribute("hidden", ""); return; }

    // Wurde er eingeloest, bleibt der Kasten stehen — als ruhige Zeile. Frueher verschwand
    // er, und mit ihm der einzige Ausschalter: die Kasse zog weiter 15 % ab, waehrend
    // "Endet in ..." laengst abgelaufen war, und der Kunde kam an den Rabatt nicht mehr
    // heran. Der Zaehler schweigt jetzt, statt gegen nichts zu laufen.
    if (timerEl) timerEl.textContent = "";
    inlineStellen();
  }

  // Unter den Preis ziehen, an den Platz der (ausgeblendeten) Willkommenszeile.
  function inlineStellen() {
    var wrap = document.querySelector("[data-hm-pd-promowrap]");
    if (wrap && wrap.parentNode && el.parentNode !== wrap.parentNode) {
      wrap.parentNode.insertBefore(el, wrap.nextSibling);
    }
    el.classList.add("hm-cb--inline");
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      st.inlineAb = Date.now();
      save(st);
      inlineStellen();
      // Der Rabattcode bleibt, falls er schon aktiviert wurde: das X fasst den Warenkorb
      // nicht an, und die 3-Tage-Frist laeuft unveraendert weiter.
    });
  }

  // Runs at the moment the box is really revealed — NOT earlier. Doing this up front
  // would strip the 10% welcome line off the page and leave the visitor with no offer
  // at all during the delay below.
  function uebernehmen() {
    // Mutually exclusive with the 10% welcome line: a returning visitor sees ONLY the
    // 15% comeback offer. Einen bereits AKTIVIERTEN Willkommensrabatt schalten wir hier
    // NICHT mehr ab — in dem Fall erscheint der Kasten laut `willkommenAktiv()` gar
    // nicht erst. Hier bleibt nur das Ausblenden der nicht aktivierten Zeile.
    ["[data-hm-pd-promowrap]", ".hm-pd__sticky-promo"].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (n) { n.style.display = "none"; });
    });

    // Der Hinweis der Kaufleiste ("Rabatt noch nicht aktiviert") gehoert zum
    // WILLKOMMENS-Rabatt, dessen Knopf wir eine Zeile darueber gerade ausblenden — er
    // zeigte also auf einen Rabatt, den es auf dieser Seite nicht mehr gibt.
    // Stillgelegt ueber seinen EIGENEN Sitzungsschluessel, nicht mit Gewalt.
    // Der Nebeneffekt ist hier der eigentliche Gewinn: die Leiste kann jetzt nicht mehr
    // wachsen, also muss der Kasten keine 25px Luft mehr dafuer reservieren und sitzt
    // dicht ueber ihr (Betreiber 2026-09-20: "naeher an die Kaufleiste").
    // Nur den Knoten entfernen, NICHT den Sitzungsschluessel `hmStickyHint` setzen: der
    // gilt shopweit und haette den Hinweis auf ALLEN Produktseiten dieser Sitzung
    // stillgelegt, auch dort, wo dieser Kasten nie erscheint. Der Regler hat seine
    // Referenz bereits; er haengt seine Klasse dann an einen abgehaengten Knoten, die
    // Leiste kann also nicht wachsen — worauf sich die Abstandsrechnung verlaesst.
    var hinweis = document.querySelector("[data-hm-sticky-hint]");
    if (hinweis) {
      hinweis.classList.remove("is--on");
      if (hinweis.parentNode) hinweis.parentNode.removeChild(hinweis);
    }

    // One source for the percentage: the price element carries what the section computed
    // (setting `promo2_prozent`). Text and checkout can therefore never drift apart.
    var priceEl = document.querySelector("[data-hm-pd-price]");
    var pct = priceEl && priceEl.getAttribute("data-promo2-pct");
    if (pct) {
      el.querySelectorAll("[data-hm-cb-pct]").forEach(function (n) { n.textContent = pct; });
    }
  }

  // Der Kasten steht IMMER ueber der Kaufleiste und BEWEGT SICH NICHT (Betreiber
  // 2026-09-20: "immer oben, ohne dass er sich bewegt"). Dafuer zaehlt nicht die
  // aktuelle, sondern die GROESSTMOEGLICHE Hoehe der Leiste — sie waechst kurzzeitig
  // am Seitenende um den Hinweis "Rabatt noch nicht aktiviert".
  //
  // Der Hinweis liegt IMMER im DOM, nur mit `max-height:0; overflow:hidden` geklemmt
  // und aufgeklappt auf 52px. `scrollHeight` liefert deshalb schon vorher seine echte
  // Inhaltshoehe — die Maximalhoehe ist damit beim Laden bekannt und muss nicht
  // beobachtet werden. Gemessen 2026-09-20 am 375er Handy: Leiste 65px, mit Hinweis
  // 90px, Toolbar 55px -> 155px Abstand, in JEDEM Scrollzustand frei.
  var HINT_MAX = 52; // == max-height der .is--on-Regel im Abschnitt
  function sichtbar(n) {
    var cs = getComputedStyle(n);
    return cs.display !== "none" && cs.visibility !== "hidden";
  }
  function abstand() {
    var unterkante = 0;
    var toolbar = document.querySelector(".t4s-toolbar");
    if (toolbar && sichtbar(toolbar)) unterkante = toolbar.offsetHeight;

    // KEINE Reserve mehr fuer den Hinweis: `uebernehmen()` legt ihn still, bevor diese
    // Rechnung beim Anzeigen laeuft. Die Leiste hat damit ihre feste Hoehe, und der
    // Kasten sitzt dicht darueber statt 25px hoeher als noetig zu schweben.
    var hoch = 0;
    var leiste = document.querySelector(".hm-pd__sticky");
    if (leiste && sichtbar(leiste)) {
      var hint = leiste.querySelector(".hm-pd__sticky-hint");
      var offen = hint && hint.classList.contains("is--on");
      hoch = leiste.offsetHeight - (offen ? Math.min(HINT_MAX, hint.scrollHeight) : 0);
    }

    // 2px statt 10: so tief wie moeglich, ohne die Kaufleiste zu beruehren. Darunter
    // beginnt er sie zu verdecken — genau der Fehler vom 2026-09-20 (Kasten lag im
    // "In den Warenkorb"-Knopf). Die Grenze liegt bei `unterkante + hoch`:
    //   Handy 375  -> 145px (Toolbar 55 + Leiste 65 + Hinweis 25)
    //   Rechner    ->  96px (keine Toolbar + Leiste 70 + Hinweis 26)
    var wert = hoch ? unterkante + hoch + 2 : (unterkante ? unterkante + 2 : 12);

    // `data-unten` am Kasten ueberschreibt die Rechnung komplett — fuer den Fall, dass
    // der Betreiber eine andere Hoehe will. Ein Wert unter der Grenze oben verdeckt
    // den Kaufknopf; das ist dann eine bewusste Entscheidung, kein Versehen.
    var fest = parseInt(el.getAttribute("data-unten"), 10);
    if (!isNaN(fest)) wert = fest;

    el.style.setProperty("--hm-cb-unten", Math.round(wert) + "px");
  }
  // Nur beim Laden und wenn sich das Fenster wirklich aendert (Drehen, Groesse).
  // BEWUSST NICHT beim Scrollen und NICHT per ResizeObserver: genau das liess den
  // Kasten vorher auf- und abwandern.
  abstand();
  addEventListener("resize", abstand);
  addEventListener("orientationchange", abstand);

  // Nicht sofort aufspringen. Ein Kasten in Sekunde 1 wirkt wie Verfolgung — und er
  // traefe den Kunden, BEVOR er ueberhaupt zoegern konnte. Gezeigt wird erst, wenn der
  // Besucher wirklich liest: Verweildauer UND einmal gescrollt. Wer sich schnell
  // entscheidet und gleich in den Korb legt, sieht den Rabatt dadurch gar nicht erst —
  // genau das schuetzt die Marge (Betreiber 2026-09-20). Kein Exit-Intent: am Handy
  // gibt es keinen Mauszeiger, der die Seite verlaesst, und Moebelkaeufer gehen
  // ohnehin nachdenken, statt zu fliehen.
  var VERZOEGERUNG = (parseInt(el.getAttribute("data-delay-sec"), 10) || 40) * 1000;
  var gezeigt = false, zeitReif = false, gescrollt = false;

  function fensterOeffnen() {
    // Frisch nachlesen statt dem Stand vom Seitenaufruf zu vertrauen: ein zweiter Tab
    // kann das Fenster inzwischen geoeffnet haben. Vorher ueberschrieb der spaeter
    // angezeigte Tab es mit seiner eigenen Startzeit — gemessen am 2026-09-20 um genau
    // das Alter des zweiten Tabs verschoben. Ein tagelang offener Tab haette die Frist
    // um Tage verlaengert und die 14-Tage-Sperre ausgehebelt.
    var frisch = load();
    if (frisch.cycleEnd && Date.now() < frisch.cycleEnd) {
      st.cycleStart = frisch.cycleStart;
      st.cycleEnd = frisch.cycleEnd;
      fensterOffen = true;
    }
    if (!fensterOffen) {
      st.cycleStart = Date.now();
      st.cycleEnd = st.cycleStart + WINDOW_MS;
      delete st.inlineAb; // neues Fenster nach der Sperrfrist: er darf wieder schweben
      fensterOffen = true;
      save(st);
    }
    end = st.cycleEnd;
  }

  // Liegt etwas UEBER dem Kasten? `hidden` zu entfernen heisst nicht, dass der Kunde ihn
  // sieht. Shopifys Zustimmungsbanner (#shopify-pc__banner) traegt z-index 2000000 und
  // deckt am Handy genau den unteren Streifen ab — am 2026-09-20 gemessen: Kasten bei
  // y 602–690, Banner 464–812, und `elementFromPoint` in der Kastenmitte lieferte das
  // Banner. Der Kasten galt als "gezeigt", die Drei-Tage-Frist lief los, und der Kunde
  // sah nie etwas. Danach 14 Tage Sperre: siebzehn Tage Angebot fuer nichts.
  // Geprueft wird an drei Punkten, weil ein schmaler Balken die Mitte treffen kann,
  // ohne den ganzen Kasten zu verdecken.
  function verdeckt() {
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return true;
    var punkte = [[r.left + r.width / 2, r.top + 8],
                  [r.left + r.width / 2, r.top + r.height / 2],
                  [r.left + r.width / 2, r.bottom - 8]];
    for (var i = 0; i < punkte.length; i++) {
      var x = Math.round(punkte[i][0]), y = Math.round(punkte[i][1]);
      if (x < 0 || y < 0 || x > innerWidth || y > innerHeight) return true;
      var oben = document.elementFromPoint(x, y);
      if (oben && (oben === el || el.contains(oben))) return false; // ein Punkt frei genuegt
    }
    return true;
  }

  function zeigen(alsZeile) {
    if (gezeigt || abgebrochen) return;
    // Zwischen Seitenaufruf und Ablauf der Verzoegerung kann er laengst gekauft oder
    // gelegt haben — deshalb hier ein zweites Mal pruefen, nicht nur am Anfang.
    if (!forcePreview && (gekauft() || schonGelegt() || willkommenAktiv() || korbRabatt === true)) return;

    // Probeweise einblenden, um messen zu koennen — die Frist laeuft dabei NOCH NICHT.
    el.removeAttribute("hidden");
    if (alsZeile) inlineStellen();
    abstand();
    if (!forcePreview && verdeckt()) {
      el.setAttribute("hidden", "");
      return; // kein Fenster, keine Uebernahme — der Waechter versucht es gleich wieder
    }

    gezeigt = true;
    fensterOeffnen();
    uebernehmen();
    tick();
    uhr = setInterval(tick, 1000);

    // Einmal ansagen, NACHDEM der Kasten im Baum steht — erst dann liest ein Screenreader
    // die Aenderung einer Live-Region verlaesslich vor.
    var ansage = el.querySelector("[data-hm-cb-ansage]");
    if (ansage) {
      var pctEl = el.querySelector("[data-hm-cb-pct]");
      var satz = "Angebot für wiederkehrende Besucher: " + (pctEl ? pctEl.textContent : "15") + " % auf Ihre Bestellung.";
      setTimeout(function () { ansage.textContent = satz; }, 150);
    }
  }

  // Auch die Zeilenform laeuft ueber den Waechter statt sofort: `korbRabatt` kommt
  // asynchron aus /cart.js, und ein synchroner Sofortaufruf ueberholte die Antwort —
  // der Kasten bot "Aktivieren" an, waehrend der Code im Korb laengst zog.
  function pruefen() {
    if (inlineModus || (zeitReif && gescrollt)) zeigen(inlineModus);
  }

  // Die Scrolltiefe wird GEMESSEN statt ueber das scroll-Ereignis erfahren.
  //
  // KORREKTUR 2026-09-20: hier stand, `scroll` erreiche das window in diesem Theme
  // ueberhaupt nicht. Das ist falsch — nachgemessen feuerten drei Ereignisse fuer drei
  // Scrollvorgaenge, und der Leisten-Hinweis desselben Abschnitts haengt seit August an
  // genau diesem Ereignis. Die urspruengliche Messung war fehlerhaft.
  // Das Abtasten bleibt trotzdem: es kennt auch Scrollen, das kein Ereignis ausloest
  // (Sprungmarken, programmatisches Scrollen, wiederhergestellte Positionen).
  var TIEFE = 300; // px — grob eine halbe Bildhoehe: er hat wirklich weitergelesen
  if (forcePreview) {
    zeigen();
  } else {
    // In der Zeilenform entfaellt die Wartezeit: eine ruhige Zeile draengt sich nicht auf.
    if (inlineModus) { zeitReif = true; gescrollt = true; }
    else setTimeout(function () { zeitReif = true; pruefen(); }, VERZOEGERUNG);
    var wachBis = Date.now() + 15 * 60000; // nach 15 min liest hier niemand mehr
    var wache = setInterval(function () {
      if (gezeigt || abgebrochen || Date.now() > wachBis) { clearInterval(wache); return; }
      var y = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      if (y > TIEFE) gescrollt = true;
      pruefen();
    }, 500);
  }
})();
